export default "__VITE_ASSET__DVOTqFv___"